module.exports = __webpack_public_path__ + "8849eca55a5d3eea6db3b9e6033f9de1.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-1050.webp.png
// module id = 466
// module chunks = 0